import { Component } from '@angular/core';

@Component({
  selector: 'notfound',
  templateUrl: './notfound.component.html',
})
export class NotFoundComponent {}
